<template>
  <div :style="(column.style as StyleValue)" :class="column.attr?.class">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { PropType, StyleValue } from 'vue';
import type { Column } from '../types/model';

defineProps({
  column: { type: Object as PropType<Column>, default: () => ({}) }
});
</script>
